import {
  ApplicationConfig,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection,
} from '@angular/core';

import { provideRouter, TitleStrategy } from '@angular/router';

import { provideAnimations } from '@angular/platform-browser/animations';
import { MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/dialog';
import { DATE_PIPE_DEFAULT_OPTIONS } from '@angular/common';

import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

import { routes } from './app.routes';

import { AuthInterceptor } from './core/interceptors/auth-interceptor';
import { AppTitleStrategy } from './core/services/others/app-title-strategy';

export const appConfig: ApplicationConfig = {
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },

    {
      provide: TitleStrategy,
      useClass: AppTitleStrategy,
    },

    provideAnimations(),

    // Every date and time in the portal is shown in IST, whatever the viewer's computer timezone.
    {
      provide: DATE_PIPE_DEFAULT_OPTIONS,
      useValue: { timezone: '+0530' },
    },

    {
      provide: MAT_DIALOG_DEFAULT_OPTIONS,
      useValue: {
        enterAnimationDuration: 360,
        exitAnimationDuration: 360,
      },
    },

    provideBrowserGlobalErrorListeners(),

    provideZoneChangeDetection({
      eventCoalescing: true,
    }),

    provideRouter(routes),

    provideHttpClient(withInterceptorsFromDi()),
  ],
};
